import React from "react";
import Invoices from "./Invoices";

const SalesInvoices: React.FC = () => {
  return <Invoices type="sales" />;
};

export default SalesInvoices;
